export enum SignatureType {
  BOTH = 0,
  DIGITAL = 1,
  ELETRONIC = 2,
  INPERSON = 3,
  DIGITAL_ClOUD = 4,
  SELFIE = 5
}